import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AppInfo } from './common/model/dictionary/AppInfo';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private appInfo: AppInfo, private router: Router, @Inject(SESSION_STORAGE) private storage: WebStorageService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.appInfo.IsLoginActivated) {
        return this.verifyLogin(state.url);
      } else {
        return true;
      }
  }

  verifyLogin(url: string): boolean {
    if (this.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  public isLoggedIn(): boolean {
    return this.storage.get('isLoggedIn');
  }

}
